export const PRIVACY_DOC = [
  { title: "Última actualización", body: "23 de septiembre de 2026" },
  {
    title: "1. Responsable del tratamiento",
    list: [
      "Identidad: Joan Riera Bauzá",
      "CIF/NIF: 43483435A",
      "Dirección: 07006, Palma de Mallorca",
      "Correo electrónico: joanriera49@gmail.com",
      "Sitio web: https://apreagestora.com/servicio",
    ],
  },
  {
    title: "2. Datos personales que recopilamos",
    body: "En https://apreagestora.com/servicio recopilamos los siguientes datos personales:",
    list: ["Nombre y apellidos", "Email", "Teléfono", "Dirección postal", "Datos de pago (tarjeta, cuenta bancaria)"],
  },
  {
    title: "3. Finalidad del tratamiento",
    body: "Los datos personales facilitados se tratan con las siguientes finalidades:",
    list: ["Gestión de consultas y solicitudes de información.", "Gestión de compras, pedidos, pagos y facturación."],
  },
  {
    title: "4. Legitimación",
    body: "La base legal para el tratamiento de sus datos es:",
    list: [
      "El consentimiento del interesado (art. 6.1.a del Reglamento (UE) 2016/679).",
      "La ejecución de un contrato (art. 6.1.b del Reglamento (UE) 2016/679).",
    ],
  },
  {
    title: "5. Destinatarios",
    body: "Sus datos podrán ser comunicados a los siguientes prestadores de servicios:",
    list: [
      "Stripe Inc. — Procesamiento de pagos. Política de privacidad: https://stripe.com/privacy",
      "HubSpot Inc. — CRM y marketing. Política de privacidad: https://legal.hubspot.com/privacy-policy",
      "Google LLC — Analítica web. Política de privacidad: https://policies.google.com/privacy",
    ],
  },
  {
    title: "6. Transferencias internacionales",
    body: "Algunos de los prestadores de servicios mencionados se encuentran en Estados Unidos. Estas transferencias están amparadas por el Marco de Privacidad de Datos UE-EE.UU. (EU-US Data Privacy Framework), decisión de adecuación adoptada por la Comisión Europea en julio de 2023.",
  },
  {
    title: "7. Plazo de conservación",
    body: "Los datos personales se conservarán mientras se mantenga la relación y no se solicite su supresión, y en cualquier caso durante los plazos legales de prescripción que resulten de aplicación.",
  },
  {
    title: "8. Derechos del usuario",
    body: "Puede ejercer los siguientes derechos ante el responsable del tratamiento:",
    list: [
      "Derecho de acceso (art. 15 RGPD)",
      "Derecho de rectificación (art. 16 RGPD)",
      "Derecho de supresión (art. 17 RGPD)",
      "Derecho de limitación del tratamiento (art. 18 RGPD)",
      "Derecho de portabilidad (art. 20 RGPD)",
      "Derecho de oposición (art. 21 RGPD)",
    ],
    after: "Para ejercer estos derechos, envía un correo a joanriera49@gmail.com indicando tu solicitud y adjuntando copia de tu documento identificativo. También tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si consideras que el tratamiento no se ajusta a la normativa.",
  },
  {
    title: "9. Modificaciones",
    body: "Joan Riera Bauzá se reserva el derecho a modificar la presente política de privacidad para adaptarla a novedades legislativas o jurisprudenciales. Se recomienda revisar esta página periódicamente. Los cambios entrarán en vigor desde su publicación en el sitio web.",
  },
];

export const AVISO_DOC = [
  { title: "Última actualización", body: "23 de septiembre de 2026" },
  {
    title: "Datos identificativos",
    body: "En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se exponen a continuación los datos identificativos del titular de este sitio web.",
    list: [
      "Titular: Joan Riera Bauzá",
      "CIF/NIF: 43483435A",
      "Domicilio: 07006, Palma de Mallorca",
      "Correo electrónico: joanriera49@gmail.com",
      "Sitio web: https://apreagestora.com/servicio",
    ],
  },
  {
    title: "2. Objeto",
    body: "El presente sitio web tiene por objeto la presentación e información de los servicios profesionales prestados por el titular, así como facilitar el contacto con los usuarios interesados en dichos servicios.",
  },
  {
    title: "3. Propiedad intelectual e industrial",
    body: "Todos los contenidos de este sitio web —textos, fotografías, gráficos, imágenes, tecnología, software, diseño gráfico, código fuente y demás elementos— son propiedad intelectual de Joan Riera Bauzá o de terceros que han autorizado su uso, sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación reconocidos por la normativa vigente en materia de propiedad intelectual e industrial. Queda expresamente prohibida la reproducción total o parcial de los contenidos de este sitio web, su transformación, distribución, comunicación pública, puesta a disposición, extracción y/o reutilización, salvo autorización expresa del titular.",
  },
  {
    title: "4. Condiciones de uso",
    body: "El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación plena y sin reservas de todas las disposiciones incluidas en este aviso legal. El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que Joan Riera Bauzá ofrece a través de su sitio web y, con carácter enunciativo pero no limitativo, a no emplearlos para:",
    list: [
      "Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.",
      "Difundir contenidos o propaganda de carácter racista, xenófobo, pornográfico o que atenten contra la dignidad de las personas.",
      "Provocar daños en los sistemas físicos y lógicos del titular o de sus proveedores.",
      "Introducir o difundir virus informáticos o cualquier otro sistema físico o lógico que sea susceptible de provocar daños en los sistemas de Joan Riera Bauzá o de terceros.",
    ],
  },
  {
    title: "5. Exclusión de responsabilidad",
    body: "Joan Riera Bauzá no se hace responsable de los daños y perjuicios de cualquier naturaleza que pudieran derivarse del acceso o del uso de los contenidos del sitio web, en particular los derivados de:",
    list: [
      "La falta de disponibilidad, mantenimiento y efectivo funcionamiento del sitio web o de sus servicios y contenidos.",
      "La existencia de virus, programas maliciosos o lesivos en los contenidos.",
      "El uso ilícito, negligente, fraudulento o contrario al presente aviso legal.",
      "La falta de licitud, calidad, fiabilidad, utilidad y disponibilidad de los servicios prestados por terceros y puestos a disposición de los usuarios en el sitio web.",
    ],
  },
  {
    title: "6. Política de enlaces",
    body: "El sitio web puede contener enlaces a páginas de terceros. Joan Riera Bauzá no asume ninguna responsabilidad por el contenido, informaciones o servicios que aparezcan en dichos sitios, que tendrán exclusivamente carácter informativo y no implican relación alguna entre Joan Riera Bauzá y las personas o entidades titulares de tales contenidos o titulares de los sitios donde se encuentren.",
  },
  {
    title: "7. Legislación aplicable y jurisdicción",
    body: "La relación entre Joan Riera Bauzá y el usuario se regirá por la legislación española vigente. Para la resolución de cualquier controversia que pudiera surgir en relación con el presente sitio web, las partes se someten a los Juzgados y Tribunales competentes conforme a la normativa aplicable, sin perjuicio de las normas de protección de los consumidores y usuarios que resulten imperativas.",
  },
];

export const COOKIES_DOC = [
  { title: "Última actualización", body: "23 de septiembre de 2026" },
  {
    title: "1. ¿Qué son las cookies?",
    body: "Las cookies son pequeños archivos de texto que los sitios web almacenan en el dispositivo del usuario cuando este los visita. Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente, para proporcionar información a los propietarios del sitio y para recordar las preferencias del usuario entre visitas. De acuerdo con el artículo 22.2 de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), y el Reglamento (UE) 2016/679 (RGPD), el usuario debe ser informado y otorgar su consentimiento previo para el uso de cookies que no sean estrictamente técnicas.",
  },
  {
    title: "2. ¿Qué cookies utilizamos?",
    body: "https://apreagestora.com/servicio utiliza los siguientes tipos de cookies:",
  },
  {
    title: "Cookies técnicas (necesarias)",
    body: "Dado que el sitio web dispone de un área privada de usuarios, se utilizan cookies de sesión de carácter técnico que son imprescindibles para autenticar al usuario y mantener su sesión activa mientras navega por el área restringida. Estas cookies no requieren consentimiento.",
  },
  {
    title: "Cookies analíticas — Google Analytics",
    table: {
      head: ["Cookie", "Proveedor", "Finalidad", "Duración", "Tipo"],
      rows: [
        ["_ga", "Google Analytics", "Distingue usuarios únicos", "2 años", "Tercero"],
        ["_gid", "Google Analytics", "Distingue usuarios (24 h)", "24 horas", "Tercero"],
        ["_ga_*", "Google Analytics (GA4)", "Mantiene el estado de la sesión", "2 años", "Tercero"],
      ],
    },
  },
  {
    title: "Cookies publicitarias",
    body: "Este sitio web no utiliza cookies publicitarias. Este sitio web incluye botones para compartir contenido en redes sociales. Estos botones pueden instalar cookies de terceros (Facebook, Twitter/X, LinkedIn, etc.) cuando el usuario interactúa con ellos o, en algunos casos, al cargar la página. Dichas cookies son gestionadas exclusivamente por las plataformas de redes sociales y su uso se rige por sus propias políticas de privacidad.",
  },
  {
    title: "3. ¿Cómo gestionar las cookies?",
    body: "Puedes configurar tu navegador para bloquear o eliminar las cookies instaladas en tu dispositivo. A continuación se indican los enlaces de configuración de los principales navegadores:",
    list: [
      "Google Chrome: chrome://settings/cookies",
      "Mozilla Firefox: about:preferences#privacy",
      "Safari: Preferencias > Privacidad > Gestionar datos del sitio web",
      "Microsoft Edge: edge://settings/privacy",
    ],
    after: "Ten en cuenta que si bloqueas o eliminas las cookies técnicas, algunas funcionalidades del sitio web podrían no estar disponibles o no funcionar correctamente.",
  },
  {
    title: "4. Actualizaciones de esta política",
    body: "Joan Riera Bauzá se reserva el derecho a modificar esta política de cookies para adaptarla a cambios normativos o a la incorporación de nuevas herramientas en el sitio web. Se recomienda revisar esta página periódicamente.",
  },
  {
    title: "5. Contacto",
    body: "Si tienes dudas sobre el uso de cookies en este sitio web, puedes contactarnos en apreagestora@gmail.com.",
  },
];

export const LEGAL_DOCS = {
  privacidad: { title: "Política de Privacidad", doc: PRIVACY_DOC },
  aviso: { title: "Aviso Legal", doc: AVISO_DOC },
  cookies: { title: "Política de Cookies", doc: COOKIES_DOC },
};
